import { ChainId } from '@uniswap/sdk-core'
import useHttpLocations from 'hooks/useHttpLocations'
import { useMemo } from 'react'
import { isAddress } from 'utilities/src/addresses'

import EthereumLogo from '../../assets/images/ethereum-logo.png'
import { DEFAULT_CHAIN_ID } from '../../constants/chains'
import { NATIVE_CHAIN_ID } from '../../constants/tokens'

type Network = 'worldchain'

export function chainIdToNetworkName(networkId: ChainId): Network {
  switch (networkId) {
    default:
      return 'worldchain'
  }
}

export function getNativeLogoURI(chainId: ChainId = DEFAULT_CHAIN_ID): string {
  switch (chainId) {
    default:
      return EthereumLogo
  }
}

function getTokenLogoURI(address: string, chainId: ChainId = DEFAULT_CHAIN_ID): string | void {
  const networkName = chainIdToNetworkName(chainId)
  const networksWithUrls = [ChainId.WORLD_CHAIN]

  if (networksWithUrls.includes(chainId)) {
    return `https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/${networkName}/assets/${address}/logo.png`
  }
}

export default function useCurrencyLogoURIs(
  currency:
    | {
        isNative?: boolean
        isToken?: boolean
        address?: string
        chainId: number
        logoURI?: string | null
      }
    | null
    | undefined
): string[] {
  const locations = useHttpLocations(currency?.logoURI)
  return useMemo(() => {
    const logoURIs = [...locations]
    if (currency) {
      if (currency.isNative || currency.address === NATIVE_CHAIN_ID) {
        logoURIs.push(getNativeLogoURI(currency.chainId))
      } else if (currency.isToken || currency.address) {
        const checksummedAddress = isAddress(currency.address)
        const logoURI = checksummedAddress && getTokenLogoURI(checksummedAddress, currency.chainId)
        if (logoURI) {
          logoURIs.push(logoURI)
        }
      }
    }
    return logoURIs
  }, [currency, locations])
}
